import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  section: { display: 'flex', flexDirection: 'column' },
  headerRowStyles: {
    '& th': { backgroundColor: '#f5f5f5', borderBottom: 'none' },
    '& th:first-of-type': { borderRadius: '14px 0 0 14px' },
    '& th:last-of-type': { borderRadius: '0 14px 14px 0' },
  },
  paper: { width: '100%', border: 'none', boxShadow: 'none', marginTop: '24px' },
  tableContainer: {
    overflow: 'auto',
    height: { xs: 'calc(100vh - 400px)', xl: 'calc(100vh - 400px)' },
  },
  columnTitle: { display: 'flex', alignItems: 'center', gap: 0.5 },
  sortBox: {
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  unfoldIcon: {
    fontSize: 16,
    color: zeplinColor.BasicBlack,
  },
  row: {
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer',
  },
  cell: {
    padding: '22px 12px',
  },
};
